import PropTypes from 'prop-types';
import { Modal, Backdrop, Box } from '@material-ui/core';
import VMTemplateSummary from './VMTemplateSummary';

VMTemplatePreviewModal.propTypes = {
  vm: PropTypes.object,
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func
};

export default function VMTemplatePreviewModal({ vm, isOpen, setIsOpen }) {
  return (
    <Box>
      <Modal
        open={isOpen}
        aria-labelledby="VM-template-Modal"
        aria-describedby="modal for VM Template data "
        BackdropComponent={Backdrop}
        data-testid="vm-template-modal"
      >
        <Box>
          <VMTemplateSummary vm={vm} isOpen={isOpen} setIsOpen={setIsOpen} />
        </Box>
      </Modal>
    </Box>
  );
}
